import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { accountDetail, accountOperation, structureList } from './request';
import { customerDetail } from './../../system/customerManage/request';
import { roleResource } from '@/api/roleManage';
import structureModel from './structureModel.vue';
export default {
  components: {
    structureModel
  },
  data() {
    return {
      roleId: [],
      structureId: undefined,
      structureShow: false,
      form: {
        structureId: '',
        roleIds: '',
        nickName: '',
        mobile: '',
        customerId: this.$route.params.customerId,
        account: '',
        email: '',
        globalRoaming: '+86'
      },
      value: '',
      nickName: '',
      roleList: [],
      treeData: [],
      treeSource: [],
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }]
    };
  },
  async created() {
    // 1、如果 $route.params.id 等于 -1
    // 2、使用 sessionStorage.getItem('globalRoaming') 获取存储在 sessionStorage 中的 globalRoaming 值。如果不存在，则默认为 '+86'。
    // 3、使用 this.$set() 方法将获取到的 globalRoaming 值设置为 form 对象的 globalRoaming 属性。
    // 4、设置 this.rules.password 数组，该数组包含两个验证规则对象：

    // 第一个规则要求密码字段为必填项，提供了相应的提示消息和触发事件。
    // 第二个规则要求密码长度为 8 到 30 之间，也提供了相应的提示消息和触发事件。
    if (this.$route.params.id == -1) {
      // let globalRoaming = sessionStorage.getItem('globalRoaming') || "+86";
      // 判断域名
      let globalRoaming = sessionStorage.getItem('globalRoaming') || "process.env.VUE_APP_BASE_API?.includes('console.insureforce.cn')? '+86': '+1'";
      this.$set(this.form, 'globalRoaming', globalRoaming);
    }
    await customerDetail({
      customerId: this.$route.params.customerId
    }).then(async res => {
      this.nickName = res.name;
      if (this.$route.params.id != -1) {
        await accountDetail({
          userId: this.$route.params.id
        }).then(res2 => {
          console.log(res2, 111);
          this.form.userId = this.$route.params.id;
          this.form.nickName = res2.nickName;
          this.form.mobile = res2.mobile;
          this.structureId = res2.structureId;
          this.form.structureId = res2.structureId;
          this.form.account = res2.account;
          this.form.email = res2.email;
          this.form.globalRoaming = res2.globalRoaming || '+86';
        });
      }
    });
    await roleResource({
      userId: this.$route.params.id != -1 ? this.$route.params.id : '',
      customerId: this.form.customerId
    }).then(res3 => {
      this.roleList = res3;
      res3.map(item => {
        if (item.selected) {
          this.form.roleIds = item.id;
        }
      });
    });
    await structureList({
      customerId: this.form.customerId
    }).then(res => {
      this.treeData = res[0].children || [];
      this.treeSource = res;
    });
  },
  computed: {
    rules() {
      return {
        nickName: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度应最少一位,最多一百位'),
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePhone
        }],
        account: [{
          required: true,
          message: this.$t('请输入') + this.$t('管理员账号'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9@.]+$/,
          message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 50,
          message: this.$t('请输入8-50字符'),
          trigger: 'blur'
        }],
        roleIds: [{
          required: true,
          message: this.$t('请选择') + this.$t('角色'),
          trigger: 'change'
        }],
        structureId: [{
          required: true,
          trigger: 'blur',
          validator: this.structureCheck
        }],
        password: this.$route.params.id == -1 ? [{
          required: true,
          message: this.$t('请输入') + this.$t('登录密码'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 16,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }] : [{
          min: 8,
          max: 16,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }],
        email: [{
          required: false,
          validator: this.checkEmail,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    checkEmail(rule, value, callback) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !regEmail.test(value)) {
        callback(new Error(this.$t('邮箱有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    changeGlobalRoaming() {
      this.$set(this.form, 'mobile', '');
    },
    structureCheck(rule, value, callbackFn) {
      if (!this.form.structureId && this.structureId != 0) {
        callbackFn(this.$t('请选择') + this.$t('账号架构'));
        return;
      }
      callbackFn();
    },
    validateAccount(rule, value, callback) {
      let reg = /^[\w@._\-]+$/;
      if (value.trim().length === 0) {
        callback(new Error(this.$t('用户名不能为空')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      } else {
        callback();
      }
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国
        SG: /^[89]\d{7}$/ // 新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.form.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('手机号')));
      } else if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码格式有误，请重新填写')));
      } else {
        callback();
      }
    },
    getStructureFun(val) {
      console.log(val);
      structureList({
        customerId: this.form.customerId
      }).then(res => {
        this.treeData = res[0].children || [];
        setInterval(() => {
          this.structureId = val;
          this.form.structureId = val;
        }, 200);
      });
    },
    onSubmit() {
      console.log(this.form.structureId, 222);
      this.$refs.form.validate(valid => {
        if (valid) {
          accountOperation(this.form).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$router.go(-1);
          });
        }
      });
    },
    onChange(value) {
      this.form.structureId = value;
    },
    filterTreeOption(input, treeNode) {
      return treeNode.data.props.title.includes(input);
    },
    addStructureFun() {
      this.structureShow = true;
      this.$nextTick(() => {
        this.$refs.structureRef.init(this.treeSource);
      });
    }
  }
};